var t = /* @__PURE__ */function (e) {
  return e.RIGHT = "right", e.LEFT = "left", e.NONE = "none", e;
}(t || {});
export { t as e };